export default __webpack_public_path__ + "static/media/hero-top-vector.3590d00b.svg";